import updateFilters from '../utilities/updateFilters';
export default function resourcesLibrary () {
	const filters = document.querySelectorAll('ul.resources-library__filters__filters li');
	//Remove previous filters and pagination
	let URL = window.location.href.split('page/')[0].split('?')[0];
		filters.forEach((el) => {
			el.addEventListener('click', function () {
				//Updates the state of the filters
				updateFilters(el, 'resources-library__filters__item--active');
				//redirect
				window.location.href = URL + '?filter=' + el.getAttribute('data-type');
			});
		});
}
